function QrsPageSubmenu({ renderItems, translate }) {
  return renderItems([
    { label: translate('list'), link: 'list' },
    { label: translate('models'), link: 'models' },
    { label: translate('printing'), link: 'printing' },
  ]);
}

export default QrsPageSubmenu;
